import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardQuestion } from "@fortawesome/free-solid-svg-icons";
import { lessonIconDefinition } from "./lessonIcons";

export interface QuizIconProps {
  readonly quizId: string;
  readonly title: string;
  readonly iconName?: string | null;
  readonly bgColor?: string | null;
  readonly fgColor?: string | null;
  readonly size?: number;
  readonly className?: string;
}

const DEFAULT_QUIZ_BG = "#1b4d2e";
const DEFAULT_QUIZ_FG = "#fdf9f3";

export function QuizIcon({
  title,
  iconName,
  bgColor,
  fgColor,
  size = 2.75,
  className,
}: QuizIconProps) {
  const background = bgColor?.trim() || DEFAULT_QUIZ_BG;
  const foreground = fgColor?.trim() || DEFAULT_QUIZ_FG;
  const initial = title.trim().charAt(0).toUpperCase() || "?";
  const icon = lessonIconDefinition(iconName) ?? faClipboardQuestion;

  return (
    <span
      className={["lesson-icon-tile", "quiz-icon-tile", className ?? ""].filter(Boolean).join(" ")}
      style={{
        width: `${size}rem`,
        height: `${size}rem`,
        background,
        color: foreground,
        fontSize: `${size * 0.45}rem`,
      }}
      title="Quiz"
      aria-label="Quiz"
    >
      <FontAwesomeIcon icon={icon} />
      <span className="visually-hidden">{initial}</span>
    </span>
  );
}
